import Banner from './Banner';
import Scopes from './Scopes';
import Benefits from './Benefits';
import Learn from './Learn';
import Clients from './Clients';

export { Banner, Scopes, Benefits, Learn, Clients };
